import React, { useEffect, useState } from "react";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AssetsBulk from './bulkFunctions/assetsBulk';
import CapacityBulk from './bulkFunctions/capacityBulk';
import CompanyBulk from "./bulkFunctions/companyBulk";
import DescriptionBulk from "./bulkFunctions/descriptionBulk";
import MakeBulk from "./bulkFunctions/makeBulk";
import MaxHeightBulk from "./bulkFunctions/maxHeightBulk";
import ModelsBulk from "./bulkFunctions/modelBulk";
import SiteLocationsBulk from "./bulkFunctions/siteLocationBulk";
import TypeBulk from "./bulkFunctions/typeBulk";

export function BulkUploads({ onClose }) {

    let [loginStatus, setLoginStatus] = useState(false);
    let [bulkAssetList, setBulkAssetList] = useState(false);
    let [bulkCompanyList, setBulkCompanyList] = useState(false);
    let [bulkCapacityList, setBulkCapacityList] = useState(false);
    let [bulkDescriptionList, setBulkDescriptionList] = useState(false);
    let [bulkMakeList, setBulkMakeList] = useState(false);
    let [bulkMaxHeightList, setBulkMaxHeightList] = useState(false);
    let [bulkModelList, setBulkModelList] = useState(false);
    let [bulkSiteLocationList, setBulkSiteLocationList] = useState(false);
    let [bulkTypeList, setBulkTypeList] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
      };

    function clearSelection() {
      setBulkAssetList(false);
      setBulkCompanyList(false);
      setBulkCapacityList(false);
      setBulkDescriptionList(false);
      setBulkMakeList(false);
      setBulkMaxHeightList(false);
      setBulkModelList(false);
      setBulkSiteLocationList(false);
      setBulkTypeList(false);
    }
  
    const bulkAssetsList = () => {
      setBulkAssetList(true);
      console.log('bulkAssetList ',bulkAssetList)
    }; 
  
    const bulkCompanieslist = () => {
      setBulkCompanyList(true);
      console.log('bulkCompanyList ',bulkCompanyList)
    }; 
  
    const bulkCapacitiesList = () => {
      setBulkCapacityList(true);
      console.log('bulkCapacityList ',bulkCapacityList)
    }; 
  
    const bulkDescriptionsList = () => {
      setBulkDescriptionList(true);
      console.log('bulkDescriptionList ',bulkDescriptionList)
    }; 
  
    const bulkMakesList = () => {
      setBulkMakeList(true);
      console.log('bulkMakeList ',bulkMakeList)
    }; 
  
    const bulkMaxHeightsList = () => {
      setBulkMaxHeightList(true);
      console.log('bulkMaxHeightList ',bulkMaxHeightList)
    }; 
  
    const bulkModelsList = () => {
      setBulkModelList(true);
      console.log('bulkModelList ',bulkModelList)
    }; 
  
    const bulkSiteLocationsList = () => {
      setBulkSiteLocationList(true);
      console.log('bulkSiteLocationList ',bulkSiteLocationList)
    }; 
  
    const bulkTypesList = () => {
      setBulkTypeList(true);
      console.log('bulkTypeList ',bulkTypeList)
    }; 

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]); 

    const canBulk = localStorage.getItem('canBulkAdd') === '1';
    const onBulkLanding = loginStatus && !bulkAssetList && !bulkCompanyList && !bulkCapacityList && !bulkDescriptionList && !bulkMakeList && !bulkMaxHeightList && !bulkModelList && !bulkSiteLocationList && !bulkTypeList;
    const bulkMenu = [
      { label: 'Bulk Add Assets', onClick: bulkAssetsList },
      { label: 'Bulk Add Companies', onClick: bulkCompanieslist },
      { label: 'Bulk Add Capacities', onClick: bulkCapacitiesList },
      { label: 'Bulk Add Descriptions', onClick: bulkDescriptionsList },
      { label: 'Bulk Add Makes', onClick: bulkMakesList },
      { label: 'Bulk Add Max Heights', onClick: bulkMaxHeightsList },
      { label: 'Bulk Add Models', onClick: bulkModelsList },
      { label: 'Bulk Add Site Locations', onClick: bulkSiteLocationsList },
      { label: 'Bulk Add Types', onClick: bulkTypesList },
    ];

    return (
        <Box sx={{ maxWidth: 820, mx: 'auto', width: '100%' }}>
          {onBulkLanding ? (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.25 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>Bulk Upload Functions</Typography>
                {onClose && (
                  <Button startIcon={<ArrowBackIcon />} variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={onClose}>
                    Back to Admin
                  </Button>
                )}
              </Box>
              <Typography variant="body2" sx={{ color: 'var(--muted)', mb: 2 }}>Choose a record type to bulk add via CSV.</Typography>
              {canBulk ? (
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, gap: 1.5 }}>
                  {bulkMenu.map(m => (
                    <Button key={m.label} variant="outlined" onClick={m.onClick}
                      sx={{ justifyContent: 'flex-start', py: 1.5, px: 2, fontSize: 14, background: 'var(--surface)', borderColor: 'var(--border)', boxShadow: 'var(--shadow-sm)' }}>
                      {m.label}
                    </Button>
                  ))}
                </Box>
              ) : null}
            </>
          ) : (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  {(bulkMenu.find(m => (
                    (m.label === 'Bulk Add Assets' && bulkAssetList) ||
                    (m.label === 'Bulk Add Companies' && bulkCompanyList) ||
                    (m.label === 'Bulk Add Capacities' && bulkCapacityList) ||
                    (m.label === 'Bulk Add Descriptions' && bulkDescriptionList) ||
                    (m.label === 'Bulk Add Makes' && bulkMakeList) ||
                    (m.label === 'Bulk Add Max Heights' && bulkMaxHeightList) ||
                    (m.label === 'Bulk Add Models' && bulkModelList) ||
                    (m.label === 'Bulk Add Site Locations' && bulkSiteLocationList) ||
                    (m.label === 'Bulk Add Types' && bulkTypeList)
                  )) || {}).label || 'Bulk Upload'}
                </Typography>
                <Button startIcon={<ArrowBackIcon />} variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={clearSelection}>
                  Return to Selection
                </Button>
              </Box>
              {bulkAssetList && canBulk && <AssetsBulk />}
              {bulkCompanyList && canBulk && <CompanyBulk />}
              {bulkCapacityList && canBulk && <CapacityBulk />}
              {bulkDescriptionList && canBulk && <DescriptionBulk />}
              {bulkMakeList && canBulk && <MakeBulk />}
              {bulkMaxHeightList && canBulk && <MaxHeightBulk />}
              {bulkModelList && canBulk && <ModelsBulk />}
              {bulkSiteLocationList && canBulk && <SiteLocationsBulk />}
              {bulkTypeList && canBulk && <TypeBulk />}
            </>
          )}
        </Box>
    )
}

export default BulkUploads